import { GlobalMessageType } from "@ehrCore/interceptors/models/global-message.model";

export enum EERROR_CATEGORY {
    API = "API_ERROR",
    VALIDATION = "VALIDATION_ERROR",
}

export enum EERROR_BEHAVIORS {
    SHOW_ERROR_PAGE = "SHOW_ERROR_PAGE",
    SHOW_TOAST = "SHOW_TOAST",
}

export class EhrBaseError extends Error {
    behavior: string;
    title: string;
    type: GlobalMessageType;
    constructor(message: string, behavior: EERROR_BEHAVIORS, title?: string, type?: GlobalMessageType) {
        super(message);
        this.name = new.target.name;
        this.behavior = behavior;
        this.title = title;
        this.type = type;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}

export class EhrApiError extends EhrBaseError {
    constructor(message: string, behavior: EERROR_BEHAVIORS) {
        super(message, behavior);
        this.name = EERROR_CATEGORY.API;
    }
}

export class EhrValidationError extends EhrBaseError {
    constructor(message: string, behavior: EERROR_BEHAVIORS) {
        super(message, behavior);
        this.name = EERROR_CATEGORY.VALIDATION;
    }
}
